<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencil, faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import useLocale from '../../composables/useLocale';

library.add(faPencil, faTrashCan);

type Emits = {
  (e: 'navigate'): void;
  (e: 'edit'): void;
  (e: 'remove'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  isSaving?: boolean;
};
defineProps<Props>();

const { t } = useLocale();
</script>

<template>
  <v-list-item class="text-left" link @click="emit('navigate')">
    <slot></slot>
    <template #append>
      <v-btn
        v-if="!isSaving"
        icon
        variant="text"
        size="small"
        :title="t('button_edit')"
        data-testid="bp-annotation-edit-btn"
        :aria-label="t('button_edit')"
        @click.stop="emit('edit')"
      >
        <FontAwesomeIcon icon="fas fa-pencil" size="lg" />
      </v-btn>
      <v-btn
        v-if="!isSaving"
        icon
        variant="text"
        size="small"
        :title="t('button_delete')"
        data-testid="bp-annotation-remove-btn"
        :aria-label="t('button_delete')"
        @click.stop="emit('remove')"
      >
        <FontAwesomeIcon icon="fas fa-trash-can" size="lg" />
      </v-btn>
      <v-progress-circular v-if="isSaving" indeterminate size="20" :width="2" />
    </template>
  </v-list-item>
</template>

<style scoped lang="scss"></style>
